import { useQuery } from "@tanstack/react-query";
import { fetchInfoOfficer } from "../services/karmachariServices";

export const useFetchInfoOfficer = () => useQuery({
  queryKey: ['infoOfficer'],
  queryFn: fetchInfoOfficer
})
